<svg
  width="21"
  height="20"
  viewBox="0 0 21 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.3276 1.6665C5.7326 1.6665 1.99426 5.40484 1.99426 9.99984C1.99426 14.5948 5.7326 18.3332 10.3276 18.3332C14.9226 18.3332 18.6609 14.5948 18.6609 9.99984C18.6609 5.40484 14.9226 1.6665 10.3276 1.6665ZM10.3276 16.6665C6.65176 16.6665 3.66093 13.6757 3.66093 9.99984C3.66093 6.324 6.65176 3.33317 10.3276 3.33317C14.0034 3.33317 16.9943 6.324 16.9943 9.99984C16.9943 13.6757 14.0034 16.6665 10.3276 16.6665Z"
    fill="currentColor"
  />
  <path
    d="M8.66012 11.3224L6.74428 9.40986L5.56762 10.5899L8.66178 13.6774L14.2501 8.08903L13.0718 6.9107L8.66012 11.3224Z"
    fill="currentColor"
  />
</svg>
